import React from 'react';
import { withTranslation } from 'react-i18next';
import InfoBar from './InfoBar';

function PrinterV3InfoBar({ isPrintable, notPrintableReason, t }) {
  const getNotPrintableMessage = (reason) => {
    // Silent reasons that should not display anything
    if (['no_jobs', 'email_missing', 'payment_needed'].includes(reason)) {
      return null;
    }

    const messages = {
      'not_enough_paper': t('printerInfoBar.notPrintable.notEnoughPaper'),
      'printer_serviced': t('printerInfoBar.notPrintable.printerServiced')
    };
    return messages[reason] || t('printerInfoBar.notPrintable.printerNotAvailable');
  };

  const message = getNotPrintableMessage(notPrintableReason);

  return (
    <>
      {/* V3 specific InfoBar components */}
      { !isPrintable && notPrintableReason && message &&
      <InfoBar
        caption={message}
        type="error" />
      }
    </>
  );
}

export default withTranslation()(PrinterV3InfoBar);
